const textFieldSignUp = {
  name: 'Full name',
  email: 'Email',
  reason: 'Reason for access'
};

export default textFieldSignUp;
